import { lazy } from 'react';

import { AppRoute } from '.';

const GlobalConfigurations = lazy(() => import('../pages/configurations/GlobalConfigurations'));

const configurationsRouter: AppRoute[] = [{
    path: '/configurations',
    component: GlobalConfigurations,
    exact: true
}];

export default configurationsRouter;
